import { createValidator } from 'revalidate';
import memoize from 'lodash/memoize';
import { INVALID_DATE_OF_BIRTH } from '../constants/defaultErrorMessages';
const getDateFormatRegex = memoize(format => {
  const [first, second, third] = format.split('-').map(x => x.length);
  return new RegExp(`^\\d{${first}}-\\d{${second}}-\\d{${third}}$`);
});
const isValidDate = (format = 'yyyy-MM-dd') => createValidator(message => date => {
  const dateRegex = getDateFormatRegex(format);
  return date && !dateRegex.test(date) ? message || INVALID_DATE_OF_BIRTH : null;
}, INVALID_DATE_OF_BIRTH);
export default isValidDate;
//# sourceMappingURL=isValidDate.js.map